module.exports = __webpack_public_path__ + "static/media/m6.1e3a984b.jpg";